<template>
  <div
    class="flex flex-row phone-screen"
    :class="smallScreen ? 'mt-14' : 'mt-2'"
  >
    <div
      v-for="(filterElement, index) in this.$store.state.extendedSearchValue
        .extendedSearch"
      :key="index"
    >
      <div
        v-if="showFilterElement(index, filterElement)"
        class="flex flex-row items-center mr-2"
        style="border: solid 1px #adacac; border-radius: 5px; padding: 2px 5px"
      >
        <div
          v-for="(t, i) in [translationField(index, filterElement)]"
          :key="i"
          class="text-xs"
        >
          <p>
            {{ t.label }}
            <span> {{ t.connector }}</span>
            {{ " " + t.value }}
          </p>
        </div>
        <span
          class="material-icons ml-1 text-sm"
          style="cursor: pointer"
          @click="removeFilterElement(index)"
          >close</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import i18n from "../../i18n";
import moment from "moment/moment";
import en from "../../locales/en.json";

export default {
  emits: ["removeLabel"],
  props: {
    currentPage: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      smallScreen: window.innerWidth < 980,
    };
  },
  mounted() {
    window.addEventListener("resize", () => (this.smallScreen = "change var"));
  },
  watch: {
    smallScreen() {
      this.smallScreen = window.innerWidth < 980;
    },
  },
  methods: {
    removeFilterElement(filterElement) {
      if (filterElement === "legalEntityNumber") {
        this.$store.state.extendedSearchValue.extendedSearch[filterElement] = {
          label: "general.allLegalEntity",
          value: null,
        };
      } else if (filterElement === "errorChannels") {
        delete this.$store.state.extendedSearchValue.extendedSearch[
          filterElement
        ];
        delete this.$store.state.extendedSearchValue.extendedSearch
          .includeHandled;
      } else if (filterElement === "peppolMessageType") {
        delete this.$store.state.extendedSearchValue.extendedSearch[
          filterElement
        ];
        delete this.$store.state.extendedSearchValue.extendedSearch
          .rejectedImrOnly;
      } else {
        delete this.$store.state.extendedSearchValue.extendedSearch[
          filterElement
        ];
      }
      this.$emit("removeLabel");
    },
    showFilterElement(field, value) {
      switch (field) {
        case "legalEntityIds":
          return value.length > 0;
        case "period":
          return !!(value.from && value.to);
        case "legalEntityNumber":
        case "legalEntityId":
        case "peppolMessageTypeOptions":
          if (value === undefined) return false;
          return value.value !== null;
        case "selectedChannels":
          if (value === undefined) return false;
          else return value.value !== "NO_CHANNEL";
        case "includeHandled":
        case "released":
        case "clientDocsOnHold":
        case "rejectedImrOnly":
          return value;
        case "documentNumber":
        case "clientId":
        case "role":
        case "transactionId":
        case "receiverId":
        case "mandateId":
        case "receiverName":
        case "senderId":
        case "senderName":
        case "status":
        case "retrieved":
        case "updatedAfter":
          return value !== undefined && value !== "";
        default:
          return (
            value.value !== undefined &&
            value.value !== null &&
            value.value !== ""
          );
      }
    },
    translationField(field, value) {
      if (
        field === "channel" &&
        value.value !== "AttachEmail" &&
        value.value !== "LinkEmail" &&
        value.value.toLowerCase() !== "print" &&
        value.value !== "NO_CHANNEL"
      ) {
        field = "channel_edi";
      }
      switch (field) {
        case "period":
          return {
            label:
              this.currentPage !== undefined
                ? i18n.t(
                    "extendedSearch.label." + field + "." + this.currentPage,
                  )
                : i18n.t("extendedSearch.documentDate"),
            connector: i18n.t("extendedSearch.label.from").toLowerCase(),
            value: `${moment(value.from).format("DD/MM/yyyy")} ${i18n.t("extendedSearch.label.to").toLowerCase()} ${moment(value.to).format("DD/MM/yyyy")}`,
          };
        case "legalEntityNumber":
        case "legalEntityId":
        case "errorCode":
        case "userId":
        case "departmentCode":
        case "batch":
        case "channel_edi":
          return {
            label: i18n.t("extendedSearch.label." + field),
            connector: i18n.t("extendedSearch.label.equals"),
            value: value.label,
          };
        case "errorChannels":
          return {
            label: i18n.t("extendedSearch.label." + field),
            connector: i18n.t("extendedSearch.label.with"),
            value: i18n.t(value.label).toLowerCase(),
          };
        case "selectedChannels":
          return {
            label: i18n.t("extendedSearch.label." + field),
            connector: i18n.t("extendedSearch.label.equals"),
            value: this.displayMultipleValues(value),
          };
        case "legalEntityIds":
          return {
            label: i18n.t("extendedSearch.label." + field),
            connector: i18n.t("extendedSearch.label.equalsPlural"),
            value: this.displayMultipleValues(value),
          };
        case "includeHandled":
        case "released":
        case "clientDocsOnHold":
        case "rejectedImrOnly":
          return {
            label: i18n.t("extendedSearch.label." + field),
            connector: "",
            value: "",
          };
        case "updatedAfter":
          return {
            label: i18n.t("extendedSearch.label." + field),
            connector: "",
            value: String(value),
          };
        case "documentNumber":
        case "clientId":
        case "role":
        case "transactionId":
        case "receiverId":
        case "senderId":
        case "senderName":
        case "receiverName":
        case "mandateId":
        case "status":
          if (
            this.currentPage !== undefined &&
            en.extendedSearch.label[field][this.currentPage] !== undefined
          ) {
            return {
              label: i18n.t(
                "extendedSearch.label." + field + "." + this.currentPage,
              ),
              connector: i18n.t("extendedSearch.label.equals"),
              value: String(value),
            };
          } else {
            return {
              label: i18n.t("extendedSearch.label." + field),
              connector: i18n.t("extendedSearch.label.equals"),
              value: String(value),
            };
          }
        default:
          return {
            label: i18n.t("extendedSearch.label." + field),
            connector: i18n.t("extendedSearch.label.equals"),
            value: i18n.t(value.label).toLowerCase(),
          };
      }
    },
    displayMultipleValues(value) {
      let text = "";
      value.forEach((channel) => {
        text += channel.label + ", ";
      });
      return text.substring(0, text.length - 2);
    },
  },
};
</script>

<style scoped>
p > span {
  color: #adacac;
}

@media only screen and (max-width: 1030px) {
  .phone-screen {
    margin-top: 55px;
  }
}

@media only screen and (max-width: 739px) {
  .phone-screen {
    margin-top: 85px;
  }
}
</style>
